import type { OnboardingValidationIssue } from "@/api/onboarding-api.types"

/**
 * Whether the preview is saying the same thing the refused submit above it already said.
 *
 * A refusal and the preview share a heading, and the preview runs again the moment the submit finishes, so
 * the reviewer would otherwise read one list twice. Only an identical list is held back: a refusal is not
 * cleared when the form is edited, so a preview that has since changed is the only account of what the form
 * would be refused for now, and hiding it would leave Proceed disabled with nothing on screen saying why.
 */
export function previewRepeatsTheRefusal(
  previewIssues: OnboardingValidationIssue[],
  submittedIssues: OnboardingValidationIssue[] | null | undefined,
): boolean {
  if (!submittedIssues?.length) {
    return false
  }

  return JSON.stringify(previewIssues) === JSON.stringify(submittedIssues)
}
